import React from 'react';
import ListItemBase from './ListItemBase';
import Box from '../../components/Box/Box';

import TListItemBasicProps from './@types/TListItemBasicProps';
import TListItemWithImageProps from './@types/TListItemWithImageProps';

// Todo: Refactor this 🧨
// Smells like modifiers and children have been mixed up

const ListItemWithImage = ({ image, children, ...rest }: TListItemBasicProps & TListItemWithImageProps) => (
  <ListItemBase as="li" kind="withImage" {...rest}>
    {image && (
      <Box as="div" name="ListItem" modifiers={['image', 'withImage']}>
        {image}
      </Box>
    )}
    <Box as="div" name="ListItem" modifiers={['content', 'withImage']}>
      {children}
    </Box>
  </ListItemBase>
);

export default ListItemWithImage;
